import { render, staticRenderFns } from "./requestsOverDue.vue?vue&type=template&id=75b78320&"
import script from "./requestsOverDue.vue?vue&type=script&lang=js&"
export * from "./requestsOverDue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports